/* =========================================================================
   reinperle - script.js  (mobile-first build)
   - daily countdown to midnight (auto-resets at 0:00)
   - scent / bundle / marquee / benefit rendering from one data source
   - mobile drawer menu + body scroll lock
   - cart counter + add-to-cart toast
   - sticky bottom CTA (mobile) shown after the hero scrolls out of view
   - newsletter submit
   ========================================================================= */

/* ---- BENEFITS bleibt vorerst hardcoded (redaktioneller Text, keine Produktdaten) ---- */
const BENEFITS = [
  { num: "01", title: "schweißhemmend",    desc: "antitranspirant-formel hält deine hände trocken – bis zu sechs stunden, ohne kleben." },
  { num: "02", title: "hygienisch sauber", desc: "reinigt deine hände in sekunden überall einsatzbereit, ganz ohne wasser." },
  { num: "03", title: "pflegend",          desc: "hyaluron + glycerin verwöhnen die haut – kein austrocknen, keine klebrigkeit." },
  { num: "04", title: "langanhaltend",     desc: "ein sprühstoß. sechs stunden frische. kein nachsprühen nötig." },
  { num: "05", title: "pocket-size",       desc: "30ml – passt in jede tasche, schminktäschchen, hosentasche. flugzeug-tauglich." },
];

const PRICE = "13 €";

/* pricing model - whole euros only (no decimals), quantity-tiered bundle pricing.
   single spray: compare 19 €, sale 13 €
   bundle tiers apply across the whole cart (more sprays = cheaper each):
     1-4 sprays - 13 € each
     5-7 sprays - 11 € each  (+ 1 gratis case)
     8+  sprays - 10 € each  (+ 2 gratis cases)
   free shipping at 40 €. */
const UNIT_COMPARE = 19;
const UNIT_PRICE   = 13;
const PRICE_TIERS  = [ { min: 8, unit: 10 }, { min: 5, unit: 11 }, { min: 1, unit: 13 } ];

const unitPriceFor = (q) => {
  for (const t of PRICE_TIERS) if (q >= t.min) return t.unit;
  return UNIT_PRICE;
};

const FREE_SHIP    = 40;
const BUNDLE_MAX   = 8;      // sprays needed for the final milestone
const UPSELL_COMPARE = 19;
const UPSELL_PRICE   = 11;

const euro  = (n) => Math.round(n).toLocaleString("de-DE") + " €";  // suffix €, no decimals
const euroP = (n) => Math.round(n).toLocaleString("de-DE") + " €";  // € steht jetzt NACH der Zahl

/* ---- tiny helpers ---- */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const fmt = (n) => n.toLocaleString("de-DE");

/* ---- benefits ---- */
function renderBenefits() {
  const grid = $("#benefits-grid");
  if (!grid) return;
  grid.innerHTML = BENEFITS.map((b, i) => `
    <div class="benefit" style="--b-delay: ${i * 90}ms">
      <div class="benefit__num">${esc(b.num)}</div>
      <div class="benefit__body">
        <div class="benefit__title">${esc(b.title)}</div>
        <div class="benefit__desc">${esc(b.desc)}</div>
      </div>
      <svg class="benefit__chev" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
    </div>`).join("");

  // dezente Scroll-Einblendung der Zeilen
  const rows = grid.querySelectorAll(".benefit");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); obs.unobserve(e.target); } });
    }, { threshold: 0.25 });
    rows.forEach((r) => io.observe(r));
  } else {
    rows.forEach((r) => r.classList.add("is-in"));
  }
}

function startCountdown() {
  const legacy = $("#countdown");
  const saleTimers = Array.from(document.querySelectorAll("[data-sale-countdown]"));
  if (!legacy && !saleTimers.length) return;

  const pad = (n) => String(n).padStart(2, "0");
  const tick = () => {
    const now = new Date();
    const end = new Date(now);
    end.setHours(24, 0, 0, 0); // next local midnight, resets every day at 0:00
    const diff = Math.max(0, Math.floor((end - now) / 1000));
    const h = pad(Math.floor(diff / 3600));
    const m = pad(Math.floor((diff % 3600) / 60));
    const s = pad(diff % 60);

    if (legacy) legacy.textContent = `${h} : ${m} : ${s}`;

    saleTimers.forEach((timer) => {
      const hours = timer.querySelector("[data-sale-hours]");
      const minutes = timer.querySelector("[data-sale-minutes]");
      const seconds = timer.querySelector("[data-sale-seconds]");
      if (hours && minutes && seconds) {
        hours.textContent = h;
        minutes.textContent = m;
        seconds.textContent = s;
      } else {
        timer.textContent = `${h} : ${m} : ${s}`;
      }
    });
  };
  tick();
  setInterval(tick, 1000);
}

/* ---- cart state + toast ---- */
let cart = [];   // { id, key, variantId, name, qty, price, comparePrice, linePrice, image }
let toastTimer = null;
let _prev = { qty: 0, free: false, m5: false, m8: false };
let _lastAdded = null;

function showToast(msg) {
  const t = $("#toast");
  if (!t) return;
  t.textContent = msg;
  t.classList.add("is-visible");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove("is-visible"), 1900);
}

/* ---- Shopify AJAX Cart: schlanker fetch-Wrapper ---- */
function shopifyRoot() {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : "/";
}

function shopifyPath(path) {
  const root = shopifyRoot().replace(/\/?$/, "/");
  return root + String(path || "").replace(/^\/+/, "");
}

async function shopifyCartRequest(url, options) {
  const res = await fetch(url, Object.assign({
    credentials: "same-origin",
    cache: "no-store",
    headers: { "Content-Type": "application/json", "Accept": "application/json" }
  }, options || {}));
  if (!res.ok) {
    let detail = "";
    try { detail = (await res.json()).description || ""; } catch (e) {}
    throw new Error(detail || ("Cart request failed: " + res.status));
  }
  return res.json();
}

function getCart() {
  return shopifyCartRequest(shopifyPath("cart.js"), { method: "GET" });
}

/* ---- Rabattcode anwenden ---- */
let _appliedDiscount = null;
let _pendingDiscount = null;
const MFY_DISCOUNT_KEY = "mfy_discount_code";

function normalizeDiscountCode(code) {
  return (code || "").trim().replace(/\s+/g, "").toUpperCase();
}

function readStoredDiscountCode() {
  try { return normalizeDiscountCode(sessionStorage.getItem(MFY_DISCOUNT_KEY) || localStorage.getItem(MFY_DISCOUNT_KEY) || ""); }
  catch (e) { return ""; }
}

function storeDiscountCode(code) {
  const clean = normalizeDiscountCode(code);
  try {
    if (clean) {
      sessionStorage.setItem(MFY_DISCOUNT_KEY, clean);
      localStorage.setItem(MFY_DISCOUNT_KEY, clean);
    } else {
      sessionStorage.removeItem(MFY_DISCOUNT_KEY);
      localStorage.removeItem(MFY_DISCOUNT_KEY);
    }
  } catch (e) {}
  updateDiscountCheckoutInputs(clean);
  return clean;
}

function updateDiscountCheckoutInputs(code) {
  const clean = normalizeDiscountCode(code);
  document.querySelectorAll('[data-discount-checkout-input]').forEach((input) => { input.value = clean; });
  const btn = document.getElementById("cart-checkout");
  if (btn) btn.dataset.checkoutUrl = discountCheckoutUrl(clean);
}

function discountStatusFor(cartObj, code) {
  const wanted = normalizeDiscountCode(code).toLowerCase();
  const list = cartObj && Array.isArray(cartObj.discount_codes) ? cartObj.discount_codes : [];
  const entry = list.find((d) => normalizeDiscountCode(d.code).toLowerCase() === wanted);
  if (!entry) return "absent";
  return entry.applicable ? "applicable" : "not_applicable";
}

function discountCheckoutUrl(code) {
  const clean = normalizeDiscountCode(code);
  const checkoutUrl = shopifyPath("checkout");
  if (!clean) return checkoutUrl;
  return shopifyPath("discount/" + encodeURIComponent(clean)) + "?redirect=" + encodeURIComponent(checkoutUrl);
}

async function touchShopifyDiscount(code) {
  const clean = normalizeDiscountCode(code);
  if (!clean) return;
  await Promise.all([
    fetch(shopifyPath("discount/" + encodeURIComponent(clean)) + "?redirect=" + encodeURIComponent(shopifyPath("cart")), {
      method: "GET",
      credentials: "same-origin",
      cache: "no-store",
      redirect: "follow"
    }).catch(() => {}),
    // Shopify ignoriert unbekannte Felder sauber; in Shops, in denen cart/update.js Rabattcodes akzeptiert,
    // sorgt das zusätzlich dafür, dass cart.js direkt mit aktualisiertem Gesamtpreis zurückkommt.
    shopifyCartRequest(shopifyPath("cart/update.js"), {
      method: "POST",
      body: JSON.stringify({ discount: clean })
    }).catch(() => null)
  ]);
}

async function clearDiscountCode() {
  _appliedDiscount = null;
  _pendingDiscount = null;
  storeDiscountCode("");
  await shopifyCartRequest(shopifyPath("cart/update.js"), {
    method: "POST",
    body: JSON.stringify({ discount: "" })
  }).catch(() => null);
}

function computeCartTotalsFromShopify(shopifyCart) {
  if (!shopifyCart) { computeCartTotals(); return; }
  if (Number.isFinite(shopifyCart.total_price)) {
    _shopifyCartTotal = Math.max(0, shopifyCart.total_price || 0);
  } else {
    computeCartTotals();
  }
  const original = Number.isFinite(shopifyCart.original_total_price)
    ? shopifyCart.original_total_price
    : _shopifyCartTotal + (Number.isFinite(shopifyCart.total_discount) ? shopifyCart.total_discount : 0);
  _shopifyCartOriginalTotal = Math.max(_shopifyCartTotal, original || _shopifyCartTotal);
}

async function applyDiscountCode(code) {
  const clean = normalizeDiscountCode(code);
  if (!clean) return { ok: false, reason: "empty" };

  await touchShopifyDiscount(clean);
  let c = await getCart();
  let status = discountStatusFor(c, clean);

  // Shopify braucht manchmal einen kurzen Moment, bis cart.js den neuen Code zeigt.
  if (status === "absent") {
    await new Promise((resolve) => setTimeout(resolve, 320));
    c = await getCart();
    status = discountStatusFor(c, clean);
  }

  mapShopifyCartItems(c);
  computeCartTotalsFromShopify(c);

  if (status === "applicable") {
    const discountValue = c.total_discount || 0;
    _appliedDiscount = { code: clean, value: discountValue };
    _pendingDiscount = null;
    storeDiscountCode(clean);
    return { ok: true, value: discountValue, cart: c };
  }

  _appliedDiscount = null;
  _pendingDiscount = null;
  storeDiscountCode("");
  return { ok: false, reason: status === "not_applicable" ? "not_applicable" : "invalid", cart: c };
}

/* ---- Warenkorb-Zählung: keine automatischen Bundle-Rabatte ---- */
function qualifyingQty() { return cartQty(); }

/* ---- PERFORMANCE & ROBUSTHEIT ---- */
let _cartOpChain = Promise.resolve();
function queueCartOp(fn) {
  const run = _cartOpChain.then(fn, fn);
  _cartOpChain = run.catch(() => {});
  return run;
}

let _pendingOps = 0;
let _lastServerCart = null;

function enqueueWrite(doWrite) {
  _pendingOps++;
  return queueCartOp(async () => {
    try {
      const c = await doWrite();
      if (c) _lastServerCart = c;
    } catch (err) {
      console.error("reinperle cart write error:", err);
      showToast("warenkorb konnte nicht aktualisiert werden");
    } finally {
      _pendingOps--;
      if (_pendingOps === 0) {
        const hasPendingDesire = Object.keys(_desiredQty).length > 0;
        if (!hasPendingDesire) {
          try {
            await applyServerCart(_lastServerCart || (await getCart()));
          } catch (e) { console.error("reinperle finalize error:", e); }
          _lastServerCart = null;
        }
      }
    }
  });
}

function productFormLineProperties() {
  const form = document.getElementById("product-upload-form");
  const props = {};
  if (!form || typeof FormData === "undefined") return props;
  try {
    const fd = new FormData(form);
    fd.forEach((value, key) => {
      const match = /^properties\[(.+)\]$/.exec(String(key || ""));
      if (!match) return;
      const propName = match[1];
      if (!propName) return;
      if (typeof File !== "undefined" && value instanceof File) {
        if (value.name) props[propName] = value.name;
        return;
      }
      const stringValue = String(value == null ? "" : value).trim();
      if (stringValue) props[propName] = stringValue;
    });
  } catch (err) {
    console.warn("uploadly properties konnten nicht gelesen werden", err);
  }
  return props;
}

function cartAdd(variantId, quantity, sellingPlan, properties) {
  var item = { id: variantId, quantity: quantity || 1 };
  if (sellingPlan) item.selling_plan = sellingPlan;
  if (properties && Object.keys(properties).length) item.properties = properties;
  return shopifyCartRequest("/cart/add.js", {
    method: "POST",
    body: JSON.stringify({ items: [item] })
  });
}

function cartChange(key, quantity) {
  return shopifyCartRequest("/cart/change.js", {
    method: "POST",
    body: JSON.stringify({ id: key, quantity: Number(quantity) })
  });
}

function cartUpdate(updates) {
  return shopifyCartRequest("/cart/update.js", {
    method: "POST",
    body: JSON.stringify({ updates: updates || {} })
  });
}

function cartLineProperties(line) {
  return line && line.properties && typeof line.properties === "object" ? line.properties : {};
}

function bundleIdFromProps(props) {
  return props && props._mf_bundle_id ? String(props._mf_bundle_id) : "";
}

function bundleRoleFromProps(props) {
  return props && props._mf_bundle_role ? String(props._mf_bundle_role) : "";
}

function bundleRequiredPaidFromProps(props) {
  const raw = props && props._mf_bundle_required_paid ? String(props._mf_bundle_required_paid) : "";
  return raw.split(",").map((id) => id.trim()).filter(Boolean);
}

function bundleIntegrityUpdatesFromItems(items) {
  const groups = Object.create(null);
  (items || []).forEach((line) => {
    const props = cartLineProperties(line);
    const bundleId = bundleIdFromProps(props);
    if (!bundleId) return;
    if (!groups[bundleId]) groups[bundleId] = [];
    groups[bundleId].push(line);
  });

  const updates = {};
  Object.keys(groups).forEach((bundleId) => {
    const lines = groups[bundleId];
    let requiredPaid = [];
    lines.forEach((line) => {
      if (!requiredPaid.length) requiredPaid = bundleRequiredPaidFromProps(cartLineProperties(line));
    });

    const presentPaid = new Set();
    let hasFree = false;
    lines.forEach((line) => {
      const props = cartLineProperties(line);
      const role = bundleRoleFromProps(props);
      const qty = Number(line.quantity || 0);
      if (role === "free" && qty > 0) hasFree = true;
      if (role === "paid" && qty > 0) presentPaid.add(String(line.variant_id));
    });

    const requiredMissing = requiredPaid.length > 0 && !requiredPaid.every((id) => presentPaid.has(String(id)));
    if (hasFree && (presentPaid.size === 0 || requiredMissing)) {
      lines.forEach((line) => {
        const props = cartLineProperties(line);
        if (bundleRoleFromProps(props) === "free") updates[line.key] = 0;
      });
    }
  });

  return updates;
}

async function enforceBundleIntegrity(shopifyCart) {
  const current = shopifyCart || (await getCart());
  const updates = bundleIntegrityUpdatesFromItems(current && current.items);
  if (!Object.keys(updates).length) return current;
  return cartUpdate(updates);
}

function mapShopifyCartItems(shopifyCart) {
  const prevByKey = Object.create(null);
  const prevOrder = [];
  for (const it of cart) { prevByKey[it.key] = it; prevOrder.push(it.key); }

  const mapped = Object.create(null);
  for (const i of shopifyCart.items) {
    const hasPending = i.key in _desiredQty;
    // Zwingend den vom Nutzer gewünschten _desiredQty Wert nutzen!
    const qty = hasPending ? _desiredQty[i.key] : i.quantity;
    
    // Wenn die Menge 0 ist (wurde gerade gelöscht), ignorieren wir das Item
    if (qty <= 0) continue; 

    const unit = i.final_price;
    const unitCompare = i.original_price;
    const linePrice = hasPending ? unit * qty : i.final_line_price;
    const compareLinePrice = hasPending ? unitCompare * qty : i.original_line_price;
    
    const props = cartLineProperties(i);
    mapped[i.key] = {
      id: i.variant_id, key: i.key, variantId: i.variant_id,
      name: i.product_title || i.title, qty: qty,
      price: unit, comparePrice: unitCompare,
      linePrice: linePrice, compareLinePrice: compareLinePrice,
      image: i.image,
      properties: props,
      bundleId: bundleIdFromProps(props),
      bundleRole: bundleRoleFromProps(props),
      bundleRequiredPaid: bundleRequiredPaidFromProps(props)
    };
  }

  const result = [];
  const used = new Set();
  for (const key of prevOrder) {
    if (mapped[key]) { result.push(mapped[key]); used.add(key); }
  }
  for (const i of shopifyCart.items) {
    if (!used.has(i.key)) { result.push(mapped[i.key]); used.add(i.key); }
  }
  cart = result;
}

function cartQty() { return cart.reduce((n, i) => n + i.qty, 0); }

/* ---- Warenkorb-Summen: echte Shopify-Preise, keine automatischen Mengenrabatte ---- */
let _shopifyCartTotal = 0;          // in Cent, echte Shopify-Finalpreise
let _shopifyCartOriginalTotal = 0;  // in Cent, Original-/Compare-Summe falls vorhanden

function computeCartTotals() {
  let total = 0;
  let originalTotal = 0;
  cart.forEach((i) => {
    const line = Number.isFinite(i.linePrice) ? i.linePrice : (i.price || 0) * (i.qty || 0);
    const compare = Number.isFinite(i.compareLinePrice) ? i.compareLinePrice : line;
    total += line;
    originalTotal += Math.max(compare, line);
  });
  _shopifyCartTotal = Math.max(0, total);
  _shopifyCartOriginalTotal = Math.max(_shopifyCartTotal, originalTotal);
}

function cartTotal() { return _shopifyCartTotal / 100; }
function cartSavings() { return Math.max(0, (_shopifyCartOriginalTotal - _shopifyCartTotal) / 100); }

function renderCart() {
  const qty = cartQty();
  const total = cartTotal();
  
  const badge = $("#cart-count"); if (badge) { badge.textContent = qty; badge.classList.toggle("is-empty", qty === 0); }
  const qEl = $("#cart-qty"); if (qEl) qEl.textContent = qty;
  
  const notice = $("#cart-notice"); if (notice) notice.hidden = qty === 0;
  const savings = cartSavings();
  const saveEl = $("#cart-save"); if (saveEl) saveEl.textContent = "-" + euroP(savings);
  const saveRow = $("#cart-save-row"); if (saveRow) { saveRow.classList.toggle("is-saving", savings > 0); saveRow.hidden = savings <= 0; }
  const totEl  = $("#cart-total"); if (totEl)  { totEl.textContent = euroP(total); }
  
  const scrollEl = document.querySelector(".cart__scroll");
  const savedScroll = scrollEl ? scrollEl.scrollTop : 0;
  const wrap = $("#cart-items");
  
  if (wrap) {
    if (cart.length === 0) {
      wrap.innerHTML = `<div class="cart__empty">dein warenkorb ist noch leer.</div>`;
    } else {
      const empty = wrap.querySelector(".cart__empty");
      if (empty) empty.remove();
      const seen = new Set();
      let prevNode = null;
      cart.forEach((i) => {
        seen.add(i.key);
        let ci = wrap.querySelector(`.ci [data-inc="${i.key}"]`);
        ci = ci ? ci.closest(".ci") : null;
        if (!ci) {
          ci = document.createElement("div");
          ci.className = "ci" + (i.key === _lastAdded ? " ci--in" : "");
          ci.innerHTML = `
            <div class="ci__thumb"><img src="${i.image || ""}" alt=""></div>
            <div class="ci__body">
              <div class="ci__name">${esc(i.name)}</div>
              <div class="ci__qty">
                <button data-dec="${i.key}" aria-label="weniger">\u2212</button>
                <span>${i.qty}</span>
                <button data-inc="${i.key}" aria-label="mehr">+</button>
              </div>
            </div>
            <div class="ci__side">
              <button class="ci__remove" data-remove="${i.key}" aria-label="entfernen">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13"/></svg>
              </button>
              <div class="ci__price"></div>
            </div>`;
        } else {
          const qs = ci.querySelector(".ci__qty span");
          if (qs && qs.textContent != i.qty) qs.textContent = i.qty;
        }
        
        const priceBox = ci.querySelector(".ci__price");
        if (priceBox) {
          const strike = i.compareLinePrice > i.linePrice ? `<span class="strike">${euroP(i.compareLinePrice / 100)}</span>` : "";
          const html = strike + `<strong>${euroP(i.linePrice / 100)}</strong>`;
          if (priceBox.innerHTML !== html) priceBox.innerHTML = html;
        }
        
        const anchor = prevNode ? prevNode.nextSibling : wrap.firstChild;
        if (ci !== anchor) wrap.insertBefore(ci, anchor);
        prevNode = ci;
      });
      
      wrap.querySelectorAll(".ci").forEach((node) => {
        const incBtn = node.querySelector("[data-inc]");
        const key = incBtn ? incBtn.dataset.inc : null;
        if (key && !seen.has(key)) node.remove();
      });
    }
  }
  
  if (scrollEl) scrollEl.scrollTop = savedScroll;
  _lastAdded = null;
  _prev = { qty };
  renderUpsell();
  syncPromoUI();
}

function syncPromoUI() {
  const form = document.getElementById("cart-promo");
  if (!form) return;
  const input = document.getElementById("promo-input");
  const btn = document.getElementById("promo-btn");
  const msg = document.getElementById("promo-msg");
  
  if (input && document.activeElement === input) return;
  
  const setMsg = (text, ok) => {
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle("is-ok", !!ok);
    msg.classList.toggle("is-err", !ok);
    msg.hidden = false;
  };
  
  if (_appliedDiscount && _appliedDiscount.code) {
    const wasActive = form.classList.contains("is-active");
    form.classList.remove("is-invalid");
    form.classList.add("is-active");
    if (input && !input.value.trim()) input.value = _appliedDiscount.code.toUpperCase();
    if (btn) btn.textContent = "aktiv";
    const msgVisible = msg && !msg.hidden;
    if (!wasActive || msgVisible) {
      setMsg("code  " + _appliedDiscount.code.toUpperCase() + "  angewendet.", true);
    }
  } else {
    form.classList.remove("is-active");
    if (btn) btn.textContent = "einlösen";
    if (msg && msg.classList.contains("is-ok")) msg.hidden = true;
  }
}

async function applyServerCart(shopifyCart) {
  mapShopifyCartItems(shopifyCart);

  const storedCode = _pendingDiscount || readStoredDiscountCode();
  const hasApplicable = (shopifyCart.discount_codes || []).some((d) => d.applicable);

  if (storedCode && cartQty() > 0 && !hasApplicable) {
    try {
      await touchShopifyDiscount(storedCode);
      shopifyCart = await getCart();
      mapShopifyCartItems(shopifyCart);
    } catch (e) {}
  }

  computeCartTotalsFromShopify(shopifyCart);

  const applicableCodes = (shopifyCart.discount_codes || [])
    .filter((d) => d.applicable);

  if (applicableCodes.length > 0) {
    const clean = normalizeDiscountCode(applicableCodes[0].code);
    _appliedDiscount = { code: clean, value: shopifyCart.total_discount || 0 };
    _pendingDiscount = null;
    storeDiscountCode(clean);
  } else if (_pendingDiscount && cartQty() === 0) {
    _appliedDiscount = null;
    storeDiscountCode(_pendingDiscount);
  } else {
    _appliedDiscount = null;
    if (cartQty() > 0) storeDiscountCode("");
  }

  renderCart();
  return shopifyCart;
}

async function syncCartFromShopify() {
  try {
    const shopifyCart = await enforceBundleIntegrity(await getCart());
    return await applyServerCart(shopifyCart);
  } catch (err) {
    console.error("reinperle cart sync error:", err);
    showToast("warenkorb konnte nicht geladen werden");
  }
}

function popEl(el) {
  if (!el) return;
  el.classList.remove("pop");
  void el.offsetWidth;
  el.classList.add("pop");
}

function renderUpsell() {
  const box = $("#upsell");
  if (!box) return;
  
  let candidates = document.querySelectorAll("#scents-grid .add");
  if (!candidates.length) candidates = document.querySelectorAll("#swatches .swatch-card[data-id]");
  if (!candidates.length) candidates = document.querySelectorAll("#mm-grid [data-pick]");
  
  let pick = null;
  for (const btn of candidates) {
    const variantId = btn.dataset.id || btn.dataset.pick;
    if (variantId && !cart.some((i) => String(i.variantId) === String(variantId))) { pick = btn; break; }
  }
  
  if (!pick) { box.hidden = true; box.dataset.id = ""; return; }
  box.hidden = false;
  const newId = pick.dataset.id || pick.dataset.pick;
  if (box.dataset.id === String(newId)) return;
  box.dataset.id = newId;
  
  const name = $("#upsell-name"); if (name) name.textContent = pick.dataset.name || "";
  const thumb = $("#upsell-thumb"); if (thumb) { thumb.innerHTML = `<img src="${pick.dataset.img || ""}" alt="">`; }
  const price = $("#upsell-price"); if (price) price.textContent = euro(UPSELL_PRICE);
  const strike = box.querySelector(".upsell__prices .strike"); if (strike) strike.textContent = euro(UPSELL_COMPARE);
}

function addItem(id, name, n, sellingPlan, properties) {
  n = n || 1;
  if (!id) return;
  openCart();
  return enqueueWrite(async () => {
    const addResp = await cartAdd(id, n, sellingPlan, properties);
    const addedLine = addResp && addResp.items ? addResp.items[0] : addResp;
    if (_pendingOps === 1 && addedLine && addedLine.key) {
      _lastAdded = addedLine.key;
      const existing = cart.find((i) => i.key === addedLine.key);
      if (existing) {
        applyOptimisticQty(addedLine.key, existing.qty + (addedLine.quantity || n));
      } else {
        const lp = addedLine.final_line_price != null ? addedLine.final_line_price : (addedLine.line_price || 0);
        const olp = addedLine.original_line_price != null ? addedLine.original_line_price : lp;
        const addedProps = cartLineProperties(addedLine);
        cart.push({
          id: addedLine.variant_id,
          key: addedLine.key,
          variantId: addedLine.variant_id,
          name: addedLine.product_title || addedLine.title || (name || ""),
          qty: addedLine.quantity || n,
          price: addedLine.final_price != null ? addedLine.final_price : addedLine.price,
          comparePrice: addedLine.original_price != null ? addedLine.original_price : addedLine.price,
          linePrice: lp,
          compareLinePrice: olp,
          image: addedLine.image || "",
          properties: addedProps,
          bundleId: bundleIdFromProps(addedProps),
          bundleRole: bundleRoleFromProps(addedProps),
          bundleRequiredPaid: bundleRequiredPaidFromProps(addedProps)
        });
        computeCartTotals();
      }
      renderCart();
    }
    showToast(`${name || (addedLine && (addedLine.product_title || addedLine.title)) || "produkt"} in den warenkorb ♥`);
    return null;
  });
}

function applyOptimisticQty(key, newQty) {
  const line = cart.find((i) => i.key === key);
  if (!line) return;
  const target = Math.max(0, newQty);
  if (target <= 0) {
    cart = cart.filter((i) => i.key !== key);
  } else {
    line.qty = target;
    if (typeof line.linePrice === "number") line.linePrice = line.price * target;
    if (typeof line.compareLinePrice === "number") {
      line.compareLinePrice = (line.comparePrice || line.price) * target;
    }
  }
  // UPDATE TOTALS DYNAMICALLY - LÖST DEN BUG BEIM REDUZIEREN DER MENGE
  computeCartTotals();
}

let _desiredQty = Object.create(null);
let _qtyWriteScheduled = Object.create(null);

function linesForBundle(bundleId) {
  if (!bundleId) return [];
  return cart.filter((line) => line.bundleId === bundleId);
}

function applyBundleOptimistic(bundleId, targetQty) {
  const lines = linesForBundle(bundleId);
  lines.forEach((line) => {
    _desiredQty[line.key] = targetQty;
    applyOptimisticQty(line.key, targetQty);
  });
  return lines;
}

function writeBundleQuantities(lines, targetQty) {
  const updates = {};
  lines.forEach((line) => { updates[line.key] = targetQty; });
  return enqueueWrite(async () => {
    const result = await cartUpdate(updates);
    lines.forEach((line) => {
      delete _desiredQty[line.key];
      _qtyWriteScheduled[line.key] = false;
    });
    return await enforceBundleIntegrity(result);
  });
}

function removeBundleGroup(bundleId) {
  const lines = applyBundleOptimistic(bundleId, 0);
  if (!lines.length) return;
  _lastAdded = null;
  renderCart();
  writeBundleQuantities(lines, 0);
}

function bundleFreeLines(bundleId) {
  if (!bundleId) return [];
  return cart.filter((line) => line.bundleId === bundleId && line.bundleRole === "free");
}

function removeLinesTogether(lines) {
  const unique = [];
  const seen = new Set();
  (lines || []).forEach((line) => {
    if (!line || !line.key || seen.has(line.key)) return;
    seen.add(line.key);
    unique.push(line);
  });
  if (!unique.length) return;
  unique.forEach((line) => {
    _desiredQty[line.key] = 0;
    applyOptimisticQty(line.key, 0);
  });
  _lastAdded = null;
  renderCart();
  writeBundleQuantities(unique, 0);
}

function removeSingleLine(line) {
  if (!line || !line.key) return;
  applyOptimisticQty(line.key, 0);
  _lastAdded = null;
  renderCart();
  _desiredQty[line.key] = 0;
  if (!_qtyWriteScheduled[line.key]) {
    _qtyWriteScheduled[line.key] = true;
    flushQtyWrite(line.key);
  }
}

function removePaidBundleLineAndBonuses(line) {
  if (!line) return;
  const bonusLines = bundleFreeLines(line.bundleId);
  removeLinesTogether([line].concat(bonusLines));
}

function changeBundleGroupQty(bundleId, targetQty) {
  targetQty = Math.max(0, Number(targetQty) || 0);
  if (targetQty <= 0) { removeBundleGroup(bundleId); return; }
  const lines = applyBundleOptimistic(bundleId, targetQty);
  if (!lines.length) return;
  _lastAdded = null;
  renderCart();
  writeBundleQuantities(lines, targetQty);
}

function flushQtyWrite(key) {
  enqueueWrite(async () => {
    const q = key in _desiredQty ? _desiredQty[key] : null;
    _qtyWriteScheduled[key] = false;
    if (q === null) return null;
    try {
      const result = await cartChange(key, q);
      return result;
    } finally {
      if (_desiredQty[key] === q) delete _desiredQty[key];
    }
  });
}

function changeQty(key, delta) {
  const line = cart.find((i) => i.key === key);
  if (!line) return;
  const target = Math.max(0, line.qty + delta);

  if (line.bundleId) {
    if (line.bundleRole === "free") {
      if (delta > 0) return;
      if (target <= 0) { removeSingleLine(line); return; }
    } else if (target <= 0) {
      removePaidBundleLineAndBonuses(line);
      return;
    }
  }

  if (target <= 0) { removeItem(key); return; }
  applyOptimisticQty(key, target);
  _lastAdded = null;
  renderCart();
  _desiredQty[key] = target;
  if (!_qtyWriteScheduled[key]) {
    _qtyWriteScheduled[key] = true;
    flushQtyWrite(key);
  }
}

function removeItem(key) {
  const line = cart.find((i) => i.key === key);
  if (!line) return;
  if (line.bundleId) {
    if (line.bundleRole === "free") { removeSingleLine(line); return; }
    removePaidBundleLineAndBonuses(line);
    return;
  }
  applyOptimisticQty(key, 0);
  _lastAdded = null;
  renderCart();
  _desiredQty[key] = 0;
  if (!_qtyWriteScheduled[key]) {
    _qtyWriteScheduled[key] = true;
    flushQtyWrite(key);
  }
}

function openCart() {
  const c = $("#cart"); if (!c) return;
  const wasOpen = c.classList.contains("is-open");
  c.hidden = false;
  void c.offsetWidth;
  c.classList.add("is-open");
  document.body.style.overflow = "hidden";
  if (!wasOpen) document.dispatchEvent(new CustomEvent("reinperle:cart-opened"));
}

function closeCart() {
  const c = $("#cart"); if (!c) return;
  c.classList.remove("is-open");
  document.body.style.overflow = "";
  setTimeout(() => { c.hidden = true; }, 300);
}


function setupDrawer() {
  const burger = $("#burger");
  const drawer = $("#drawer");
  if (!burger || !drawer) return;
  const open = () => {
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add("is-open");
    burger.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  };
  const close = () => {
    drawer.classList.remove("is-open");
    burger.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    setTimeout(() => { drawer.hidden = true; }, 300);
  };
  burger.addEventListener("click", open);
  drawer.addEventListener("click", (e) => { if (e.target.closest("[data-drawer-close]")) close(); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !drawer.hidden) close(); });
}

function setupStickyCta() {
  const cta = $("#sticky-cta");
  const hero = $(".hero");
  if (!cta || !hero || !("IntersectionObserver" in window)) return;
  const footer = document.querySelector(".footer");
  let heroPassed = false;   // Hero rausgescrollt?
  let footerSeen = false;   // Footer erreicht?

  const setPad = () => {
    document.documentElement.style.setProperty(
      "--sticky-h",
      cta.classList.contains("is-visible") ? cta.offsetHeight + "px" : "0px"
    );
  };
  const update = () => {
    // Sichtbar nur, wenn Hero vorbei UND Footer noch nicht erreicht (und mobil)
    const show = heroPassed && !footerSeen && window.innerWidth < 1040;
    cta.classList.toggle("is-visible", show);
    setPad();
  };

  const heroIo = new IntersectionObserver(([entry]) => {
    heroPassed = !entry.isIntersecting;
    update();
  }, { rootMargin: "-60px 0px 0px 0px" });
  heroIo.observe(hero);

  // Footer: sobald er ins Bild kommt, Sticky-Bar ausblenden
  if (footer) {
    const footIo = new IntersectionObserver(([entry]) => {
      footerSeen = entry.isIntersecting;
      update();
    }, { rootMargin: "0px 0px 0px 0px" });
    footIo.observe(footer);
  }
}

let _checkoutBusy = false;
async function goToCheckout(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }
  if (_checkoutBusy) return;
  _checkoutBusy = true;

  const btn = document.getElementById("cart-checkout");
  if (btn) {
    btn.disabled = true;
    btn.classList.add("is-loading");
  }

  let code = _appliedDiscount && _appliedDiscount.code ? _appliedDiscount.code : readStoredDiscountCode();
  try {
    const cleanCart = await enforceBundleIntegrity(await getCart());
    const syncedCart = await applyServerCart(cleanCart);
    const active = (syncedCart.discount_codes || []).find((d) => d.applicable);
    if (active && active.code) code = normalizeDiscountCode(active.code);
    if (code) await touchShopifyDiscount(code);
  } catch (err) {
    console.error("magazinforyou checkout cart guard error:", err);
  }

  window.location.assign(discountCheckoutUrl(code));
}

function setupCheckoutButton() {
  const btn = document.getElementById("cart-checkout");
  const form = document.getElementById("cart-checkout-form");
  if (!btn || btn.dataset.checkoutReady === "1") return;
  btn.dataset.checkoutReady = "1";

  btn.addEventListener("click", goToCheckout, true);
  btn.addEventListener("touchend", goToCheckout, { passive: false });
  if (form) form.addEventListener("submit", goToCheckout);
}

function bindEvents() {
  setupCheckoutButton();

  document.addEventListener("click", (e) => {
    const checkout = e.target.closest("[data-checkout-button]");
    if (checkout) { goToCheckout(e); return; }
    const add = e.target.closest(".add");
    if (add) { addItem(add.dataset.id, add.dataset.name); return; }
    if (e.target.closest("[data-cart-open]")) { openCart(); return; }
    if (e.target.closest("[data-cart-close]")) { closeCart(); return; }
    const inc = e.target.closest("[data-inc]");
    if (inc) { changeQty(inc.dataset.inc, +1); return; }
    const dec = e.target.closest("[data-dec]");
    if (dec) { changeQty(dec.dataset.dec, -1); return; }
    const rem = e.target.closest("[data-remove]");
    if (rem) { removeItem(rem.dataset.remove); return; }
    if (e.target.closest("#upsell-add")) {
      const box = $("#upsell");
      if (box && box.dataset.id) addItem(box.dataset.id);
      return;
    }
  });

  const promoForm = $("#cart-promo");
  if (promoForm) {
    const input = $("#promo-input");
    const btn = $("#promo-btn");
    const msg = $("#promo-msg");
    const showMsg = (text, ok) => {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle("is-ok", !!ok);
      msg.classList.toggle("is-err", !ok);
      msg.hidden = false;
    };
    
    promoForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const code = normalizeDiscountCode(input ? input.value : "");
      promoForm.classList.remove("is-invalid", "is-active", "is-loading");
      
      if (!code) {
        if (_appliedDiscount || _pendingDiscount) {
          btn.disabled = true;
          _pendingDiscount = null;
          await clearDiscountCode();
          await syncCartFromShopify();
          btn.disabled = false;
          btn.textContent = "einlösen";
          if (msg) { showMsg("rabattcode aus dem feld entfernt.", true); }
          const saveEl = $("#cart-save"); if (saveEl) popEl(saveEl);
          const totEl = $("#cart-total"); if (totEl) popEl(totEl);
        } else {
          btn.classList.remove("nudge"); void btn.offsetWidth; btn.classList.add("nudge");
        }
        return;
      }
      btn.disabled = true;
      promoForm.classList.add("is-loading");
      const original = btn.textContent;
      btn.textContent = "prüfen";
      
      try {
        if (cartQty() === 0) {
          try {
            await touchShopifyDiscount(code);
          } catch (e) {}
          _pendingDiscount = code;
          storeDiscountCode(code);
          btn.textContent = original;
          promoForm.classList.remove("is-invalid", "is-active", "is-loading");
          showMsg("code vorgemerkt – füge produkte hinzu, dann wird er angewendet.", true);
          if (input && !input.value.trim()) input.value = code.toUpperCase();
          return;
        }
        const res = await applyDiscountCode(code);
        if (res.ok) {
          promoForm.classList.add("is-active");
          btn.textContent = "aktiv";
          showMsg("code '" + code.toUpperCase() + "' angewendet.", true);
          renderCart();
          const saveEl = $("#cart-save"); if (saveEl) popEl(saveEl);
          const totEl = $("#cart-total"); if (totEl) popEl(totEl);
        } else {
          btn.textContent = original;
          promoForm.classList.remove("is-invalid"); void promoForm.offsetWidth;
          promoForm.classList.add("is-invalid");
          renderCart();
          showMsg(res.reason === "not_applicable"
            ? "code gilt für diesen warenkorb nicht."
            : "dieser code ist leider ungültig.", false);
        }
      } catch (err) {
        btn.textContent = original;
        promoForm.classList.add("is-invalid");
        showMsg("code konnte nicht geprüft werden.", false);
      } finally {
        promoForm.classList.remove("is-loading");
        btn.disabled = false;
      }
    });
    
    if (input) {
      input.addEventListener("input", () => {
        promoForm.classList.remove("is-invalid");
        const active = _appliedDiscount ? _appliedDiscount.code.toUpperCase() : null;
        const typed = input.value.trim().toUpperCase();
        if (promoForm.classList.contains("is-active") && active && typed !== active) {
          promoForm.classList.remove("is-active");
          if (btn) btn.textContent = "einlösen";
          if (msg) {
            if (typed === "") {
              showMsg("… einlösen drücken, um den code zu entfernen.", true);
            } else {
              msg.hidden = true;
            }
          }
        }
      });
    }
    
    let nudgeTimer;
    document.addEventListener("reinperle:cart-opened", () => {
      clearTimeout(nudgeTimer);
      nudgeTimer = setTimeout(() => {
        if (!promoForm.classList.contains("is-active") && btn && (!input || !input.value.trim())) {
          btn.classList.remove("nudge"); void btn.offsetWidth; btn.classList.add("nudge");
        }
      }, 2600);
    });
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeCart();
  });

  const form = $("#newsletter-form");
  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      form.reset();
      showToast("willkommen in der reinperle family ♥");
    });
  }
}

function initProductPage() {
  const root = document.querySelector(".pdp") || document.querySelector(".pdp__top");
  if (!root) return;
  let qty = 1;

  function currentSellingPlan() {
    const pick = document.querySelector("#purchase-pick .pseg__opt.is-active");
    const val = pick ? (pick.dataset.sellingPlan || "") : "";
    return val || null;
  }

  function setPurchaseMode(activeCard) {
    const pick = document.getElementById("purchase-pick");
    if (!pick || !activeCard) return;
    const opts = Array.prototype.slice.call(pick.querySelectorAll(".pseg__opt"));
    opts.forEach((c) => {
      const on = c === activeCard;
      c.classList.toggle("is-active", on);
      c.setAttribute("aria-pressed", on ? "true" : "false");
    });
    const isRight = opts.indexOf(activeCard) === 1;
    pick.classList.toggle("is-right", isRight);
    
    const plan = activeCard.dataset.sellingPlan || "";
    const input = document.getElementById("selling-plan-input");
    if (input) input.value = plan;
    const buyAdd = document.getElementById("buy-add");
    if (buyAdd) {
      if (plan) buyAdd.dataset.sellingPlan = plan;
      else delete buyAdd.dataset.sellingPlan;
    }
  }

  function updateAddTotal() {
    const activeSwatch = document.querySelector("#swatches .swatch.is-active");
    const t = $("#buy-add-total");
    if (t && activeSwatch && activeSwatch.dataset.price) t.textContent = activeSwatch.dataset.price;
    const q = $("#q-val"); if (q) q.textContent = qty;
  }

  root.addEventListener("click", (e) => {
    const pickCard = e.target.closest(".pseg__opt");
    if (pickCard) { setPurchaseMode(pickCard); return; }
    
    const th = e.target.closest("[data-thumb]");
    if (th) {
      const track = $("#gallery-track");
      const idx = parseInt(th.dataset.index, 10);
      if (track && !isNaN(idx) && track.children[idx]) {
        track.children[idx].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      } else {
        const img = $("#gallery-img");
        if (img) { img.style.opacity = 0; setTimeout(() => { img.src = th.dataset.thumb; img.style.opacity = 1; }, 130); }
      }
      document.querySelectorAll("[data-thumb]").forEach((t) => t.classList.toggle("is-active", t === th));
      return;
    }
    
    const sw = e.target.closest("[data-sw]");
    if (sw) {
      document.querySelectorAll("[data-sw]").forEach((t) => t.classList.toggle("is-active", t === sw));
      const optName = $("#opt-name"); if (optName) optName.textContent = sw.dataset.name || "";
      const stickyName = $("#sticky-name"); if (stickyName) stickyName.textContent = sw.dataset.name || "";
      const stickyPrice = $("#sticky-price"); if (stickyPrice) stickyPrice.textContent = sw.dataset.price || "";
      const buyAdd = $("#buy-add");
      if (buyAdd) {
        buyAdd.dataset.variant = sw.dataset.sw;
        buyAdd.dataset.name = sw.dataset.name || "";
        const variantInput = document.getElementById("product-form-variant-id");
        if (variantInput) variantInput.value = sw.dataset.sw;
      }
      updateAddTotal();
      return;
    }
    if (e.target.closest("#q-inc")) { qty++; updateAddTotal(); return; }
    if (e.target.closest("#q-dec")) { qty = Math.max(1, qty - 1); updateAddTotal(); return; }
    
    const buyAdd = e.target.closest("#buy-add");
    if (buyAdd) {
      addItem(buyAdd.dataset.variant, buyAdd.dataset.name, qty, currentSellingPlan(), productFormLineProperties());
      qty = 1; updateAddTotal(); return;
    }
  });

  const stickyAdd = $("#sticky-add");
  if (stickyAdd) {
    stickyAdd.addEventListener("click", () => {
      const buyAdd = $("#buy-add");
      const variantId = buyAdd && buyAdd.dataset.variant;
      addItem(variantId, buyAdd && buyAdd.dataset.name, qty, currentSellingPlan(), productFormLineProperties());
      qty = 1; updateAddTotal();
    });
  }

  const fl = $("#faq-list");
  if (fl) {
    fl.addEventListener("click", (e) => {
      const q = e.target.closest(".faq__q"); if (!q) return;
      const item = q.closest(".faq__item");
      const a = item.querySelector(".faq__a");
      const open = item.classList.toggle("is-open");
      a.style.maxHeight = open ? a.scrollHeight + "px" : "0px";
    });
  }

  const sticky = $("#pdp-sticky"), anchor = $(".buy__row");
  if (sticky && anchor && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(([en]) => {
      sticky.classList.toggle("is-visible", !en.isIntersecting && window.innerWidth < 1040);
      document.documentElement.style.setProperty("--sticky-h", sticky.classList.contains("is-visible") ? sticky.offsetHeight + "px" : "0px");
    }, { rootMargin: "0px 0px -40px 0px" });
    io.observe(anchor);
  }

  const galTrack = $("#gallery-track");
  if (galTrack) {
    const setActive = (idx) => {
      document.querySelectorAll(".gthumb").forEach((t) =>
        t.classList.toggle("is-active", parseInt(t.dataset.index, 10) === idx)
      );
    };
    let scrollT;
    galTrack.addEventListener("scroll", () => {
      clearTimeout(scrollT);
      scrollT = setTimeout(() => {
        const idx = Math.round(galTrack.scrollLeft / galTrack.clientWidth);
        setActive(idx);
      }, 60);
    });
    
    let down = false, startX = 0, startScroll = 0, moved = false;
    const main = galTrack.closest(".gallery__main");
    galTrack.addEventListener("pointerdown", (e) => {
      if (e.pointerType === "mouse") {
        down = true; moved = false;
        startX = e.clientX; startScroll = galTrack.scrollLeft;
        if (main) main.classList.add("is-grabbing");
      }
    });
    galTrack.addEventListener("pointermove", (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      galTrack.scrollLeft = startScroll - dx;
    });
    const endDrag = () => {
      if (!down) return;
      down = false;
      if (main) main.classList.remove("is-grabbing");
      const idx = Math.round(galTrack.scrollLeft / galTrack.clientWidth);
      if (galTrack.children[idx]) {
        galTrack.children[idx].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
    };
    galTrack.addEventListener("pointerup", endDrag);
    galTrack.addEventListener("pointerleave", endDrag);
    galTrack.addEventListener("click", (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  // ---- Wirkung-Section: Zahlen zählen hoch, sobald sie sichtbar werden ----
  const impactNums = document.querySelectorAll("#impact-grid .impact__num");
  if (impactNums.length && "IntersectionObserver" in window) {
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);
    const runCount = (el) => {
      const valEl = el.querySelector(".impact__val");
      if (!valEl || el.dataset.counted === "1") return;
      el.dataset.counted = "1";
      const to = parseFloat(el.dataset.countTo);
      const decimals = parseInt(el.dataset.countDecimals, 10) || 0;
      if (isNaN(to)) { valEl.textContent = el.dataset.countTo || ""; return; }
      const dur = 1400; const start = performance.now();
      const tick = (now) => {
        const p = Math.min(1, (now - start) / dur);
        const cur = to * easeOut(p);
        valEl.textContent = cur.toFixed(decimals).replace(".", ",");
        if (p < 1) requestAnimationFrame(tick);
        else valEl.textContent = to.toFixed(decimals).replace(".", ",");
      };
      requestAnimationFrame(tick);
    };
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { runCount(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    impactNums.forEach((n) => io.observe(n));
  }

  // ---- Ablauf-Section (3 Sekunden): Schritte erscheinen nacheinander ----
  const howSteps = document.querySelectorAll("#how-steps .how__step");
  if (howSteps.length && "IntersectionObserver" in window) {
    const howIo = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.3 });
    howSteps.forEach((s) => howIo.observe(s));
  } else {
    // Fallback ohne Observer: direkt sichtbar
    howSteps.forEach((s) => s.classList.add("is-in"));
  }

  // ---- Clean-Beauty-Section: Karten beim Scrollen einblenden ----
  const cleanCards = document.querySelectorAll("#clean-grid .clean__card");
  if (cleanCards.length && "IntersectionObserver" in window) {
    const cleanIo = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.25 });
    cleanCards.forEach((c) => cleanIo.observe(c));
  } else {
    cleanCards.forEach((c) => c.classList.add("is-in"));
  }

  // ---- Produkt-Anatomie: Labels nacheinander einblenden ----
  const anatomyPoints = document.querySelectorAll("#anatomy-stage .anatomy__point");
  if (anatomyPoints.length && "IntersectionObserver" in window) {
    const anatomyIo = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.2 });
    anatomyPoints.forEach((pt) => anatomyIo.observe(pt));
  } else {
    anatomyPoints.forEach((pt) => pt.classList.add("is-in"));
  }

  updateAddTotal();
}

function initBundlePage() {
  const grid = $("#mm-grid");
  if (!grid) return;
  const sel = new Set();
  const fill = $("#mm-fill"), status = $("#mm-status");
  const m5 = $("#mm-mile-5"), m8 = $("#mm-mile-8");
  const bar = $("#mm-bar"), barThumbs = $("#mm-bar-thumbs"), barCount = $("#mm-bar-count"), barPrice = $("#mm-bar-price"), addBtn = $("#mm-add");
  const stickyWrap = $("#mm-sticky"), stickyFill = $("#mm-sticky-fill"), stickyStatus = $("#mm-sticky-status"), stickyCount = $("#mm-sticky-count");
  const progressEl = document.querySelector(".mm__progress");

  function update(justReached) {
    const n = sel.size;
    if (fill) fill.style.width = Math.min(100, (n / 8) * 100) + "%";
    const m5on = n >= 5, m8on = n >= 8;
    if (m5) m5.classList.toggle("is-reached", m5on);
    if (m8) m8.classList.toggle("is-reached", m8on);
    
    let statusHTML;
    if (n === 0) statusHTML = "stelle dein set zusammen – bis zu 47&thinsp;%.";
    else if (n < 5) statusHTML = `noch <strong>${5 - n}</strong> sprays bis zur 1. gratis case.`;
    else if (n < 8) statusHTML = `<strong>1 gratis case</strong> – noch <strong>${8 - n}</strong> sprays bis 2 cases.`;
    else statusHTML = `<strong>2 gratis cases</strong> freigeschaltet ✓`;
    if (status) status.innerHTML = statusHTML;
    
    if (stickyFill) stickyFill.style.width = Math.min(100, (n / 8) * 100) + "%";
    if (stickyStatus) {
      stickyStatus.innerHTML = n === 0 ? "stelle dein set zusammen"
        : n < 5 ? `noch <strong>${5 - n}</strong> bis zur gratis case`
        : n < 8 ? `1 case – noch <strong>${8 - n}</strong> bis 2 cases`
        : `<strong>2 gratis cases ♥</strong>`;
    }
    if (stickyCount) stickyCount.textContent = `${n} / 8`;
    
    if (barThumbs) {
      const ids = [...sel];
      const shown = ids.slice(0, 4);
      const extra = ids.length - shown.length;
      let html = shown.map((id) => {
        const card = grid.querySelector(`[data-pick="${id}"]`);
        const imgSrc = card ? card.dataset.img : "";
        return `<span class="mm-bar__thumb"><img src="${imgSrc || ""}" alt=""></span>`;
      }).join("");
      if (extra > 0) html += `<span class="mm-bar__thumb mm-bar__thumb--more">+${extra}</span>`;
      barThumbs.innerHTML = html;
    }
    
    if (barCount) barCount.textContent = n === 0 ? "noch keine sprays gewählt" : `${n} ${n === 1 ? "spray" : "sprays"} gewählt`;
    if (barPrice) barPrice.innerHTML = "";
    if (addBtn) addBtn.disabled = n === 0;
    if (bar) bar.classList.toggle("is-active", n > 0);
    if (justReached && (justReached === 5 || justReached === 8)) { popEl(justReached === 8 ? m8 : m5); }
  }

  grid.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-pick]");
    if (!btn) return;
    const id = btn.dataset.pick;
    let reached = 0;
    if (sel.has(id)) { sel.delete(id); }
    else { sel.add(id); if (sel.size === 5 || sel.size === 8) reached = sel.size; }
    btn.classList.toggle("is-picked", sel.has(id));
    btn.setAttribute("aria-pressed", sel.has(id) ? "true" : "false");
    update(reached);
  });

  if (addBtn) addBtn.addEventListener("click", () => {
    if (!sel.size) return;
    addBtn.disabled = true;
    const picked = [...sel];
    openCart();
    queueCartOp(async () => {
      try {
        for (const id of picked) await cartAdd(id, 1);
        await syncCartFromShopify();
        showToast(`${picked.length} sprays ins set gelegt ♥`);
        sel.clear();
        grid.querySelectorAll("[data-pick].is-picked").forEach((b) => { b.classList.remove("is-picked"); b.setAttribute("aria-pressed", "false"); });
        update(0);
      } catch (err) {
        console.error("reinperle bundle add error:", err);
        showToast("set konnte nicht hinzugefügt werden");
      } finally {
        addBtn.disabled = sel.size === 0;
      }
    });
  });

  if (stickyWrap && progressEl && "IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyWrap.classList.toggle("is-visible", scrolledPast);
      });
    }, { threshold: 0 });
    io.observe(progressEl);
  }
  update(0);
}

function addToCartSilent(id, name) {
  return cartAdd(id, 1);
}

function initScentQuiz() {
  const stage = document.getElementById("quiz-stage");
  if (!stage) return;
  const steps = Array.from(stage.querySelectorAll(".quiz__step"));
  const resultWrap = stage.querySelector(".quiz__result");
  const bar = stage.querySelector("#quiz-bar");
  const totalQ = steps.length;
  let current = 0;
  const scores = {};

  function showStep(idx) {
    steps.forEach((s, i) => s.classList.toggle("is-active", i === idx));
    resultWrap.classList.remove("is-active");
    if (bar) bar.style.width = ((idx) / totalQ * 100) + "%";
  }

  function tally(answerId) {
    // answerId z.B. "q1a" -> data-q1a enthält den Schlüssel
    const key = stage.dataset[answerId];
    if (key) scores[key] = (scores[key] || 0) + 1;
  }

  function showResult() {
    if (bar) bar.style.width = "100%";
    // Gewinner-Schlüssel ermitteln (erstes Maximum)
    let winner = null, max = -1;
    Object.keys(scores).forEach((k) => { if (scores[k] > max) { max = scores[k]; winner = k; } });
    steps.forEach((s) => s.classList.remove("is-active"));
    resultWrap.classList.add("is-active");
    const cards = resultWrap.querySelectorAll(".quiz__result-card");
    let shown = false;
    cards.forEach((c) => {
      const match = c.dataset.result === winner;
      c.classList.toggle("is-shown", match);
      if (match) shown = true;
    });
    // Fallback: erste Karte zeigen, falls kein Treffer
    if (!shown && cards.length) cards[0].classList.add("is-shown");
  }

  stage.querySelectorAll(".quiz__opt").forEach((btn) => {
    btn.addEventListener("click", () => {
      tally(btn.dataset.answer);
      current++;
      if (current >= totalQ) showResult();
      else showStep(current);
    });
  });

  const restart = stage.querySelector("#quiz-restart");
  if (restart) restart.addEventListener("click", () => {
    current = 0;
    Object.keys(scores).forEach((k) => delete scores[k]);
    resultWrap.querySelectorAll(".quiz__result-card").forEach((c) => c.classList.remove("is-shown"));
    showStep(0);
  });

  showStep(0);
}

function initRetailReveal() {
  const els = document.querySelectorAll("#retail-media, #retail-content");
  if (!els.length) return;
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); obs.unobserve(e.target); } });
    }, { threshold: 0.2 });
    els.forEach((el) => io.observe(el));
  } else {
    els.forEach((el) => el.classList.add("is-in"));
  }
}

function initRoutine() {
  const routineSteps = document.querySelectorAll("#routine-steps .routine__step");
  const routineSlides = document.querySelectorAll(".routine__stage .routine__slide");
  if (!routineSteps.length || !routineSlides.length) return;
  const activateRoutine = (idx) => {
    routineSteps.forEach((s) => {
      const on = s.dataset.routineIndex === String(idx);
      s.classList.toggle("is-active", on);
      s.setAttribute("aria-selected", on ? "true" : "false");
    });
    routineSlides.forEach((sl) => {
      sl.classList.toggle("is-active", sl.dataset.routineSlide === String(idx));
    });
  };
  routineSteps.forEach((s) => {
    s.addEventListener("click", () => activateRoutine(s.dataset.routineIndex));
    s.addEventListener("mouseenter", () => activateRoutine(s.dataset.routineIndex));
  });
}

function __reinperleInit() {
  renderBenefits();
  syncCartFromShopify();
  startCountdown();
  setupDrawer();
  setupStickyCta();
  initProductPage();
  initBundlePage();
  initScentQuiz();
  initRetailReveal();
  initRoutine();
  bindEvents();
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", __reinperleInit);
else __reinperleInit();